import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface IProps {
  className?: string;
}

const BlockShimmer = (props: IProps) => {
  const { className } = props;
  return (
    <div
      className={twMerge(
        clsx({
          'rounded-3xl animate-pulse bg-mobile-gray-100 h-4 w-full': true,
        }),
        className
      )}
    />
  );
};

export default BlockShimmer;
